export const acscriptsAddress = {
    ID: process.env.REACT_APP_URL_ID,
    EHR: process.env.REACT_APP_URL_EHR,
    EHR_API: process.env.REACT_APP_URL_EHR_API,
    NOTI: process.env.REACT_APP_URL_NOTI,
    ERX: process.env.REACT_APP_URL_ERX,
    BILLING: process.env.REACT_APP_URL_BILLING,
    ClientSupport: process.env.REACT_APP_URL_CLIENTSUPPORT,
    Vendor: process.env.REACT_APP_URL_VENDOR,
    Registration: process.env.REACT_APP_URL_REGISTRATION,
    Registration_API: process.env.REACT_APP_URL_REGISTRATION_API
};

export const stripeKey = {
    StripePublicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY_SECRET
};

export const rollbarAccessToken = process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN;

export const reactAppEnvironment = process.env.REACT_APP_ENVIRONMENT;

export const reactGoogleAPIKey = process.env.REACT_APP_GOOGLE_API_KEY;



// WEBPACK FOOTER //
// ./src/appconfig.ts